// PrimaryButton.jsx
import React from "react";

export default function PrimaryButton({
  children,
  className = "",
  type = "button",
  ...props
}) {
  return (
    <button
      type={type}
      {...props}
      className={
        `
        w-[358px] h-[48px] px-8 py-3
        flex justify-center items-center
        bg-[#006CE0] rounded-[10px] border-0 cursor-pointer
        transition-colors duration-300

        hover:bg-[#0059ba]

        disabled:cursor-not-allowed
        disabled:opacity-50
        disabled:hover:bg-[#006CE0]
        disabled:pointer-events-none
        ` + className
      }
    >
      <span className="font-bold text-[16px] leading-6 tracking-[-0.01em] text-white">
        {children}
      </span>
    </button>
  );
}